import React, { useContext, useState } from 'react'
import { NavigationHeader } from '@/components/NavigationHeader/NavigationHeader'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { PermissionsEnum } from 'api/Identity/Types/PermissionsEnum'
import { WalletDto } from 'api/Wallet/Types/Wallet'
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal'
import { useTabNavigate } from 'hooks/useTabNavigate'
import { AuthSessionContext } from 'utils/AuthContext'
import { hasPermission } from 'utils/permissionsValidator'

interface Props {
  data: WalletDto
  isEdit: boolean
  tab: WalletTab
}

export enum WalletTab {
  DETAILS = 'details',
  TRADING_ACCOUNTS = 'trading-accounts',
  TRANSACTIONS = 'transactions',
}

export const WalletNavigation: React.FC<Props> = (props) => {
  const tabNavigate = useTabNavigate()

  const [auth] = useContext(AuthSessionContext)
  const { data, isEdit } = props
  const [confirmationModal, setConfirmationModal] = useState<boolean>(props.isEdit)
  const [keyToChange, setKeyToChange] = useState<string>(WalletTab.DETAILS)
  const permissions = auth?.permissions || []

  const handleTabClick = async (key: string) => {
    setKeyToChange(key)
    if (isEdit) {
      setConfirmationModal(true)
    } else {
      tabNavigate(key, {
        relative: 'path',
        state: { walletId: props.data.id, clientId: props.data.client.id },
      })
    }
  }

  const handleTabChange = (reason: boolean) => {
    if (reason) {
      tabNavigate(keyToChange, {
        relative: 'path',
        state: { walletId: props.data.id, clientId: props.data.client.id },
      })
    }
    setConfirmationModal(false)
  }

  return (
    <div>
      <ConfirmationModal
        contentText='The page is asking you to confirm that you want to leave - data you have enter may not be saved.'
        yesButtonText='Leave Page'
        cancelButtonText='Stay on page'
        onYes={() => handleTabChange(true)}
        onCancel={() => handleTabChange(false)}
        visible={confirmationModal}
      />
      <NavigationHeader>{data && <span>{data.name}</span>}</NavigationHeader>
      <Tabs value={props.tab} onValueChange={handleTabClick} className='mt-2'>
        <TabsList>
          {hasPermission(permissions, PermissionsEnum.CanViewWallet) && (
            <TabsTrigger value={WalletTab.DETAILS}>Wallet details</TabsTrigger>
          )}

          {hasPermission(permissions, PermissionsEnum.CanViewWalletTradingAccounts) && (
            <TabsTrigger value={WalletTab.TRADING_ACCOUNTS}>Trading accounts</TabsTrigger>
          )}

          {hasPermission(permissions, PermissionsEnum.CanViewWalletTransactions) && (
            <TabsTrigger value={WalletTab.TRANSACTIONS}>Transactions</TabsTrigger>
          )}
        </TabsList>
      </Tabs>
    </div>
  )
}
